import React, {Component} from "react";
import {Col, Row} from "antd";
import {connect} from "react-redux";
import {formatAmount} from "../../../../services/utils";
import {
  updateFollowUpPricePerUnit,
  updateFollowUpRegistrantsCountPerMonth,
} from "../../../../actions/actions/eventStats";
import {Input} from "antd/lib/index";

class FollowUpRow extends Component {
  handleRegistrantsCountChange = (index, value) => {
    if (isNaN(value)) return;
    const {updateFollowUpRegistrantsCountPerMonth} = this.props;
    updateFollowUpRegistrantsCountPerMonth(index, value);
  }

  handlePricePerUnitChange = (index, value) => {
    if (isNaN(value)) return;
    const {updateFollowUpPricePerUnit} = this.props;
    updateFollowUpPricePerUnit(index, value);
  }

  render() {
    const {
      style,
      budgetManagement,
      index,
      realizedHTVA,
      registrantsCount,
      totalHTVA,
      followUpPricePerUnit
    } = this.props;

    const currentMonth = new Date().getMonth() ;
    const currentYear = new Date().getFullYear();

    return (
      <Row className="follow-up-row px-3" style={style}>
        <Col span={4} style={{display: "flex", justifyContent: "right"}}>
          {(currentYear > budgetManagement.year || index <= currentMonth) &&
          <label
            className="follow-up-is-saved-label">{formatAmount(realizedHTVA, false)}</label>
          }
        </Col>
        <Col span={2} style={{display: "flex", justifyContent: "right"}}>
          {(currentYear > budgetManagement.year || index <= currentMonth) &&
          <div>
            <img
              src={`/img/icons/manage-BM/BM_${
                budgetManagement.followUp[index].isPositive ? "plus" : "moins"
              }.svg`}
              className="mr-1"
            />
          </div>
          }
        </Col>
       
        {(currentYear > budgetManagement.year || budgetManagement.appType === 'all' || (currentYear == budgetManagement.year && index < currentMonth) )  ?
          <Col className={'flex px-2 justify-end'} span={6} >
            <label
              className="follow-up-is-saved-label ">{registrantsCount}</label>
          </Col>
          :
          <Col className={'flex justify-end'} span={6} >
            <input value={registrantsCount} className="follow-up-input"
                   onChange={(event) => this.handleRegistrantsCountChange(index, event.target.value)}
                    disabled={budgetManagement.isUpdatingSetUp}
            />
          </Col>
        }
        {(currentYear > budgetManagement.year || budgetManagement.appType === 'all'|| (currentYear == budgetManagement.year && index < currentMonth))  ?
          <Col className={'flex px-2 justify-end'} span={6}>
            <label
              className="follow-up-is-saved-label">{formatAmount(followUpPricePerUnit, false)}</label>
          </Col>
          :
          <Col className={'flex justify-end'} span={6}>
            <div className="follow-up-input-antd">
              <Input suffix='€' value={followUpPricePerUnit}
                     onChange={(event) => this.handlePricePerUnitChange(index, event.target.value)}
                     disabled={budgetManagement.isUpdatingSetUp}/>
            </div>

          </Col>
        }
        <Col className={'flex justify-end'} span={6}>
          <div
            className="follow-up-label">{formatAmount(totalHTVA, false)}</div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  budgetManagement: state.budgetManagement,
});

const mapDispatchToProps = {
  updateFollowUpRegistrantsCountPerMonth,
  updateFollowUpPricePerUnit
};

export default connect(mapStateToProps, mapDispatchToProps)(FollowUpRow);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/BudgetManagement/FollowUpRow.js